var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 5H13L15.6667 11.6667L12.3333 13.6667C13.7613 16.562 16.1046 18.9054 19 20.3333L21 17L27.6667 19.6667V25C27.6667 25.7072 27.3857 26.3855 26.8856 26.8856C26.3855 27.3857 25.7072 27.6667 25 27.6667C19.799 27.3506 14.8935 25.142 11.2091 21.4576C7.52467 17.7731 5.31607 12.8676 5 7.66667C5 6.95942 5.28095 6.28115 5.78105 5.78105C6.28115 5.28095 6.95942 5 7.66667 5Z",
    stroke: "#313131",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBlack);
export default __webpack_public_path__ + "static/media/call_black.ec8ff2dd50d396b5b144f982a17bf186.svg";
export { ForwardRef as ReactComponent };